<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Segmentos de socios con rasgos comunes.
                Ej.: mayoristas, minoristas, corporativos. 
                Úsalo para aplicar precios, promociones o
                reglas distintas por segmento.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Grupos
          </h2>
        </div>

        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los <b>grupos</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">
            Grupos de Socios de Negocio
          </div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <!-- Add button (only icon) -->
          <button
            mat-icon-button
            color="primary"
            (click)="openCreateModal()"
            matTooltip="Nuevo Registro"
          >
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent"
              mat-table
              [dataSource]="dataSource"
              matSort
              [trackBy]="trackByFn"
            >
              <!-- Código -->
              <ng-container matColumnDef="code">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Compañía
                </th>
                <td
                  mat-cell
                  *matCellDef="let businessPartnerGroup"
                  class="text-sm uppercase"
                >
                  {{ businessPartnerGroup.company.name }}
                </td>
              </ng-container>

              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  Nombre
                </th>
                <td
                  mat-cell
                  *matCellDef="let businessPartnerGroup"
                  class="text-sm uppercase leading-tight"
                >
                <div *ngIf="getCode(businessPartnerGroup) as code">
                  <b class="f-10">{{ code }}</b>
                </div>
                  {{ businessPartnerGroup.name }}
                </td>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                  Estado
                </th>
                <td
                  mat-cell
                  *matCellDef="let businessPartnerGroup"
                  class="px-6 text-left"
                >
                  <mat-slide-toggle
                    class="custom-slide-toggle primary"
                    [checked]="businessPartnerGroup.statusId == 1"
                    [(ngModel)]="businessPartnerGroup.statusId"
                    [color]="'success'"
                    (ngModelChange)="onStatusChange($event, businessPartnerGroup)"
                  >
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="px-6 py-3 text-left"
                ></th>
                <td
                  mat-cell
                  *matCellDef="let businessPartnerGroup"
                  class="px-6 py-3 text-left"
                >
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="actionMenu"
                    matTooltip="Acciones"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button
                      mat-menu-item
                      (click)="openEditModal(businessPartnerGroup)"
                    >
                      <mat-icon
                        svgIcon="heroicons_outline:pencil-square"
                      ></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="openDeleteDialog(businessPartnerGroup)"
                    >
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"
              ></tr>

              <!-- Fila principal -->
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                class="border-b"
              ></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator
            class="z-10"
            [pageSizeOptions]="[50, 100, 150, 200]"
            showFirstLastButtons
            [length]="totalItems"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            (page)="onPageChange($event)"
          ></mat-paginator>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #createForm="ngForm">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              [(ngModel)]="currentCreateBusinessPartnerGroup.name"
              name="name"
              required
            />
          </mat-form-field>
          <!-- Select Compañía -->
          <div class="col-span-1">
            <label>Compañía</label>
            <ng-select
              [(ngModel)]="currentCreateBusinessPartnerGroup.companyId"
              [items]="companyList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccione una compañía"
              name="companyId"
              required
            >
            </ng-select>
          </div>
          <!-- Select Price List -->
          <!-- <div class="col-span-1">
            <label>Lista de Precios</label>
            <ng-select
              [(ngModel)]="currentCreateBusinessPartnerGroup.priceListId"
              [items]="priceList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccione una lista de precios"
              name="priceListId"
              
            >
            </ng-select>
          </div> -->
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button
          mat-raised-button
          color="primary"
          (click)="createBusinessPartnerGroup()"
          [disabled]="!createForm.valid"
          >
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #editForm="ngForm">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              [(ngModel)]="currentUpdateBusinessPartnerGroup.name"
              name="name"
              required
            />
          </mat-form-field>

          <!-- Select Compañía -->
          <div class="col-span-1">
            <label>Compañía</label>
            <ng-select
              [(ngModel)]="currentUpdateBusinessPartnerGroup.company._id"
              [items]="companyList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccionar"
              name="companyId"
              required
            >
            </ng-select>
          </div>

          <!-- Select Lista de Precio -->
          <!-- <div class="col-span-1">
            <label>Lista de Precios</label>
            <ng-select
              [(ngModel)]="currentUpdateBusinessPartnerGroup.priceList"
              [items]="priceList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccionar"
              name="priceListId"
              [appendTo]="'body'"
              [compareWith]="compareById"
              (ngModelChange)="onPriceSelectionChange($event)"
            >
            </ng-select>
          </div> -->
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button
          mat-raised-button
          color="primary"
          (click)="updateBusinessPartnerGroup(currentUpdateBusinessPartnerGroup._id)"
          [disabled]="!editForm.valid"
          >
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar -->
    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon
            svgIcon="heroicons_outline:exclamation-triangle"
            class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"
          ></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <!-- Filtros -->
  <app-filter
    (onFilterEvent)="findAllWithCount()"
    (onCleanEvent)="clearFilters()"
    (onPanelOpened)="onFilterPanelOpened()"
  >
    <app-configuration-filters
          [form]="form"
          [company]="true"
          [loadData]="loadFiltersData"
        ></app-configuration-filters>
  </app-filter>
</mat-sidenav-container>
